window.addEventListener("load", function(){ // Ready

    if(document.getElementById('wrapper-navbar')) {

        var wrapperNavbar = document.getElementById('wrapper-navbar')
        var mainNav = document.getElementById('main-nav')
        // alert('cè!! ' + wrapperNavbar.offsetHeight)
    } else {
        var wrapperNavbar = {offsetHeight: 0}
        var mainNav = {offsetHeight: 0}
        // alert('non cè!!')
    }

    /** Min height: (100vh - menu height) */
    let hClass = document.getElementsByClassName("min-h-100js")

    function nl_resize_vh() {
        if(hClass.length) {
            for (const element of hClass) {
                let hh =  (window.innerHeight - mainNav.offsetHeight)
                element.style.minHeight = hh + 'px'

                setTimeout(() => {
                    element.style.opacity = '1'
                }, 100);
             }
        }
    }
    nl_resize_vh()

    if(document.getElementById('gallery')) {
        let gallery = document.getElementById('gallery')
        gallery.style.minHeight = gallery.offsetHeight + 'px'
    }


    /** Set NavBar Height */
    function setWrapperNavbarHeight() {
        if(mainNav.offsetHeight != 0) {
            // let mainNav = document.getElementById('main-nav')
            wrapperNavbar.style.height = mainNav.offsetHeight + 'px'
            document.documentElement.style.setProperty('--mobile-navbar-height', mainNav.offsetHeight + 'px')
        }
    }
    setWrapperNavbarHeight()

    /** Stato grafico del pulsante mobile: hamburger / chiudi */
    var navbarOffcanvas = document.getElementById('navbarNavOffcanvas')
    var navbarToggler = document.querySelector('#main-nav .navbar-toggler')

    if (navbarOffcanvas && navbarToggler) {
        var openMenuLabel = navbarToggler.getAttribute('aria-label')

        navbarOffcanvas.addEventListener('show.bs.offcanvas', function () {
            mainNav.classList.add('menu-open')
            navbarToggler.setAttribute('aria-expanded', 'true')
            navbarToggler.setAttribute('aria-label', 'Chiudi menu')
        })

        navbarOffcanvas.addEventListener('hidden.bs.offcanvas', function () {
            mainNav.classList.remove('menu-open')
            navbarToggler.setAttribute('aria-expanded', 'false')
            navbarToggler.setAttribute('aria-label', openMenuLabel)
        })
    }

    /** On Window resize */
    window.addEventListener('resize', function (event) { /** Windows resize *** */
        if(document.getElementById('wrapper-navbar')) {
            setTimeout(() => {
                /** Set NavBar Height */
                if(mainNav.offsetHeight != 0) {
                    setWrapperNavbarHeight()
                }
            }, 300);
        }

        nl_resize_vh()
    }, true);
    /** END Windows resize */
});
